




































import Vue from "vue";
import { modalService } from "@/services/modal-service.ts";
import { getNextMember, getPreviousMember } from "@/resources/content/team.ts";
import { Member } from "@/resources/models/app-interfaces";

export default Vue.extend({
  name: "ModalPopup",
  data() {
    return {
      showModal: false,
      currentMember: <any>{
        title: "",
        image: "",
        imageAlt: "",
        description: "",
      },
    };
  },
  created() {
    this.$subscribeTo(modalService.listenModal(), (member: Member) => {
      if (!member) return;

      this.showModal = true;
      this.currentMember = member;
    });
  },
  methods: {
    closeModal(event: any) {
      const targetName = event.target.className;

      if (targetName === "modal") {
        this.showModal = false;
      }
    },
    previousMember() {
      this.currentMember = getPreviousMember(this.currentMember);
    },
    nextMember() {
      this.currentMember = getNextMember(this.currentMember);
    },
  },
});
